module.exports = __webpack_public_path__ + "static/talona-DND3_FnP-e3bc0673d8ca4d7c0fd9d80ddfdec33c.webp";